import React from 'react'

import menuService from '../Service/menuService'
// import Cari_Obat from '../CariObat/modalSearch'
import { config } from '../Config/config'
import ListObat from '../CariObat/listObat'
import Cari_Doctor from '../Doctor/index'


export default class Menu extends React.Component {
    constructor() {
        super()
        this.state = {
            ListM: [],
            ListT: [],
            showModalCari: false,
            showModalDoctor:false
        }
    }


    loadList = async () => {
        const responM = await menuService.getByCodeM("ROLE_PUBLIC")
        const responT = await menuService.getByCodeT("ROLE_PUBLIC")
        if (responM.success) {
            this.setState({
                ListM: responM.result,
                ListT: responT.result
            })
        }
    }

    componentDidMount() {
        this.loadList()
    }

    showModal = () => {
        this.setState({
            showModalCari: true
        })
    }

    showModalDoctor =()=>{
        this.setState({
            showModalDoctor:true
        })
    }

    cancelModal = () => {
        this.setState({
            showModalCari: false,
            showModalDoctor:false
        })
    }

    render() {
        const { ListM, ListT } = this.state
        return (

            <div class="container">
                <div class="row">
                    <div class="col-3">
                        {/* <a href="javascript:void(0)" onClick={this.showModal}> */}
                        <a href="javascript:void(0)">
                            <div class="card kartu shadow p-3 mb-5 bg-body rounded">
                                <img class="rounded-circle mx-auto d-block mt-4" src="assets/img/icon/search_black_48dp.svg" width="100" alt="Admin" />
                                <div class="card-body">
                                    <h5 class="card-title text-center">Cari Obat</h5>
                                </div>
                            </div>
                        </a>
                    </div>
                    <div class="col-3">
                        <a href="javascript:void(0)" onClick={this.showModalDoctor}>
                            <div class="card kartu shadow p-3 mb-5 bg-body rounded">
                                <img class="rounded-circle mx-auto d-block mt-4" src="assets/img/icon/search_black_48dp.svg" width="100" alt="Admin" />
                                <div class="card-body">
                                    <h5 class="card-title text-center">Cari Doctor</h5>
                                </div>
                            </div>
                        </a>
                    </div>
                    {
                        ListM.map(data => {
                            return (
                                <div class="col-3">
                                    <a href={data.url}>
                                        <div class="card kartu shadow p-3 mb-5 bg-body rounded">
                                            <img class="rounded-circle mx-auto d-block mt-4" src="assets/img/logo-dark.png" width="100" alt="Admin" />
                                            <div class="card-body">
                                                <h5 class="card-title text-center">{data.nama}</h5>
                                            </div>
                                        </div>
                                    </a>
                                </div>
                            )
                        })
                    }
                    {
                        ListT.map(data => {
                            return (
                                <div class="col-3">
                                    <a href={data.url}>
                                        <div class="card kartu shadow p-3 mb-5 bg-body rounded">
                                            <img class="rounded-circle mx-auto d-block mt-4" src={data.big_icon} width="100" alt="Admin" />
                                            <div class="card-body">
                                                <h5 class="card-title text-center">{data.nama}</h5>
                                            </div>
                                        </div>
                                    </a>
                                </div>
                            )
                        })
                    }
                </div>
                {/* <Cari_Obat
                    showModalCari={this.state.showModalCari}
                    cancelModal={this.cancelModal}
                /> */}
                <Cari_Doctor
                    showModalDoctor={this.state.showModalDoctor}
                    cancelModal={this.cancelModal}
                />
            </div>

        )
    }
}